import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as objectPath from 'object-path';
import { LanguageType } from 'src/metronic/core/_config/i18n/language-type.model';
import { LayoutConfigService, SplashScreenService } from '../../../../core/_base/layout';

@Component({
  selector: 'kt-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  loaderLogo: string;
  loaderType: string;
  loaderMessage: string;

  @ViewChild('splashScreen', { static: true }) private readonly splashScreen: ElementRef;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initLogos(LanguageType[this.translateService.getBrowserLang()]);
    this.initLanguageChanges();
    this.initLoader();
    this.splashScreenService.init(this.splashScreen);
  }


  private initLogos(languageType: LanguageType): void {
    this.loaderLogo = this.layoutConfigService.getLoaderLogo(languageType);
  }

  private initLanguageChanges(): void {
    this.translateService.onLangChange
      .subscribe((lce: LangChangeEvent) => {
        this.initLogos(LanguageType[lce.lang]);
        this.cdr.detectChanges();
      });
  }

  private initLoader(): void {
    const loaderConfig = this.layoutConfigService.getConfig('loader');
    this.loaderType = objectPath.get(loaderConfig, 'type');
    this.loaderMessage = objectPath.get(loaderConfig, 'message');
  }
}
